import { render } from "./SidebarBody.vue?vue&type=template&id=a7f72472&scoped=true"
import script from "./SidebarBody.vue?vue&type=script&lang=js"
export * from "./SidebarBody.vue?vue&type=script&lang=js"

import "./SidebarBody.vue?vue&type=style&index=0&id=a7f72472&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7f72472"]])

export default __exports__